import { useMutation, useQuery } from '@tanstack/react-query'
import { api, json } from '../api/client'
import type { Billing, EpisodeCosts } from '../api/types'
import { billingKey, episodeKey } from './useShows'

/** Plan, balance, prices and history. Refetched now and then: jobs are charged when they finish. */
export function useBilling(ws: string) {
  return useQuery({ queryKey: billingKey(ws), queryFn: () => api<Billing>(`/workspaces/${ws}/billing`), refetchInterval: 30_000 })
}

/** Start a Stripe Checkout and send the browser there. */
export function useCheckout(ws: string) {
  return useMutation({
    mutationFn: (input: { kind: 'premium' } | { kind: 'pack'; credits: number }) =>
      api<{ url: string }>(`/workspaces/${ws}/billing/checkout`, { method: 'POST', body: json(input) }),
    onSuccess: ({ url }) => window.location.assign(url),
  })
}

export function usePortal(ws: string) {
  return useMutation({
    mutationFn: () => api<{ url: string }>(`/workspaces/${ws}/billing/portal`, { method: 'POST' }),
    onSuccess: ({ url }) => window.location.assign(url),
  })
}

/** What each paid action on an episode is expected to cost. */
export function useEpisodeCosts(ws: string, id: string) {
  return useQuery({ queryKey: [...episodeKey(ws, id), 'costs'], queryFn: () => api<EpisodeCosts>(`/workspaces/${ws}/episodes/${id}/costs`) })
}
